import React from 'react';
import { ConsultantOnLightBg } from 'commonComponents/Consultants/ConsultantPhotoAndName/ConsultantPhotoAndName';
import styles from './Experts.module.scss';

const Experts = ({ experts }) => {
  return (
    <div className={ styles.Experts }>
      { experts && experts.map(person =>
        <ConsultantOnLightBg
          { ...person }
          key={ person.name }
        />)
      }
    </div>
  );
};
 
export default Experts;
